// Vue compiles the server-rendered body as its root template; `<` is re-escaped
// to `&lt;` in innerHTML, so escaped user data can never form this delimiter.
export default function hardenInDomTemplates(app) {
  app.config.compilerOptions.delimiters = ['<{', '}>'];
}
